<div class="entity-selector-container">
    <div class="entity-selector-wrapper" (click)="onEntityFocus()">
        <mat-form-field class="entity-selector-field" appearance="outline">
            <mat-label class="entity-label">
                <mat-icon class="entity-icon">database</mat-icon>
                Select Entity
            </mat-label>
            <input matInput 
                   type="text" 
                   [formControl]="entityControl" 
                   placeholder="Search entities..." 
                   (blur)="onEntityBlur()"
                   autocomplete="off"
                   class="entity-input" />
            <mat-icon matSuffix class="search-icon">search</mat-icon>
            <button *ngIf="entityControl.value" 
                    mat-icon-button 
                    matSuffix 
                    (click)="clearEntityField($event)" 
                    class="clear-button">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
<!-- Dropdown for entity options -->
        <div class="entity-dropdown" *ngIf="showDropdown && (filteredOptions$ | async)?.length > 0">
            <div class="dropdown-header">
                <span class="dropdown-title">Available Entities</span>
                <span class="dropdown-count">{{(filteredOptions$ | async)?.length}} entities</span>
            </div>
            <div class="dropdown-content">
                <div class="entity-option" 
                     *ngFor="let option of filteredOptions$ | async" 
                     (click)="onEntityOptionSelected(option)"
                     [class.selected]="selectedEntity?.entityName === option.entityName">
                    <div class="option-content">
                        <mat-icon class="option-icon">table_chart</mat-icon>
                        <div class="option-details">
                            <div class="option-name">{{option.displayName}}</div>
                            <div class="option-subtitle">{{option.entityName}}</div>
                        </div>
                    </div>
                    <mat-icon class="check-icon" *ngIf="selectedEntity?.entityName === option.entityName">check</mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
